// Claude: SessionTerminatedModal — always mounted; shows graceful exit modal when session is kicked 18-04-2026
import React, { useEffect, useState } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter,
  Button, Text, Box,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "../../redux/Actions";

const SessionTerminatedModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = useSelector((state: any) => state.user?.role);

  useEffect(() => {
    const handler = () => setIsOpen(true);
    window.addEventListener("session-terminated", handler);
    return () => window.removeEventListener("session-terminated", handler);
  }, []);

  const handleOk = () => {
    setIsOpen(false);
    dispatch(actions.user.logout());
    navigate(role === 'Admin' ? '/admin/login' : '/login');
  };

  return (
    <Modal isOpen={isOpen} onClose={() => {}} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent bg="#1a2040" borderRadius="12px" mx={4}>
        <ModalBody pt={6} pb={2}>
          <Text color="white" fontWeight={700} fontSize="md" mb={3}>
            Session Ended
          </Text>
          <Text color="whiteAlpha.800" fontSize="sm">
            Your session has been ended because this account was logged in on another device.
            Please log in again to continue.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            bg="secondary.main" color="white" size="sm"
            _hover={{ opacity: 0.85 }}
            onClick={handleOk}
          >
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SessionTerminatedModal;
